import { featuresState } from "../states/featuresState"
import { mediaActions } from "../states/media/actions"
import { setLogLevel } from "./logger"

export function processCommand(command: string) {
  if(command === '/summary on') {
    featuresState.summaryShow = true
    return true
  } else if(command === '/summary off') {
    featuresState.summaryShow = false
    return true
  } else if(command.startsWith('/blur ')) {
    const cleared = command.replace('/blur ', '')
    const size = parseInt(cleared)
    if(size) {
      mediaActions.setBlurSize(size / 1080)
      return true
    } else {
      return false
    }
  } else if(command === '/log DEBUG') {
    setLogLevel('DEBUG')
    return true
  } else if(command === '/log INFO') {
    setLogLevel('INFO')
    return true
  } else if(command === '/log WARN') {
    setLogLevel('WARN')
    return true
  } else if(command === '/log ERROR') {
    setLogLevel('ERROR')
    return true
  }
  return false
}
